import createDataContext from './createDataContext'

interface StateType {
    receivingPendingData: any
}

interface ActionType {
    payload: any,
    type: string
}

const initialState: StateType = {
    receivingPendingData: {}
}

const reducer = (state, action: ActionType) => {

    switch(action.type)
    {
        case 'setReceivingPendingData': return { ...state, receivingPendingData: action.payload }

        default: return state
    }

}

const setReceivingPendingData = dispatch => {

    return async (variables, getAllDocumentsForVendorSortingEntity, callback?, err_callback?: (message) => void) => {

        try
        {

            const response = await getAllDocumentsForVendorSortingEntity({ variables })

            console.log(response.data?.getAllDocumentsForVendorSortingEntity?.data)

            dispatch({ type: 'setReceivingPendingData', payload: response.data?.getAllDocumentsForVendorSortingEntity })

            !!callback ? callback?.(response.data?.getAllDocumentsForVendorSortingEntity) : null

        } catch(e)
        {
            console.log('RECEIVING PENDING DATA', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

export interface ReceivingPendingInterface {
    state: StateType,
    setReceivingPendingData: (variables, getAllDocuments, callback?: (data) => void, err_callback?: (message) => void) => Promise<void>
}

export const { Context: ReceivingPendingContext, Provider: ReceivingPendingProvider } = createDataContext(reducer,
    { setReceivingPendingData },
    initialState)
